import React from 'react';

const ORComponent = () => {
    return (
        <div className="flex items-center my-5">
            <div className="flex-1 h-0.5 bg-gray-400"></div>
            <div className="mx-3 text-gray-500 font-bold">OR</div>
            <div className="flex-1 h-0.5 bg-gray-400"></div>
        </div>
    )
}

export default ORComponent;
